import PropTypes from 'prop-types';

import { AuditValueSide } from './EntityAuditHistory.constants';

export const AuditClientPropType = PropTypes.shape({
  getEntityAuditHistory: PropTypes.func.isRequired,
  getEntityAuditRecordDetail: PropTypes.func.isRequired,
});

/** `summary.kind` -> Component({ change, row, detail }) rendering that summarised change. */
export const AuditRenderersPropType = PropTypes.objectOf(PropTypes.elementType);

/** Field name -> Component({ value, change, row, detail }) rendering one side of that field's change. */
export const AuditFieldRenderersPropType = PropTypes.objectOf(PropTypes.elementType);

export const AuditFieldListPropType = PropTypes.arrayOf(PropTypes.string);

/** One side of a diff value as the host sent it: a JSON scalar or structure. */
export const AuditValuePropType = PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.number,
  PropTypes.bool,
  PropTypes.object,
  PropTypes.array,
]);

export const AuditValueSidePropType = PropTypes.oneOf(Object.values(AuditValueSide));

/** The props every `fieldRenderers` component receives, for one side of the change. */
export const AuditFieldRendererPropTypes = {
  value: AuditValuePropType.isRequired,
  side: AuditValueSidePropType.isRequired,
  change: PropTypes.shape({
    field: PropTypes.string.isRequired,
    old: AuditValuePropType,
    new: AuditValuePropType,
  }).isRequired,
  row: PropTypes.object,
  detail: PropTypes.shape({
    before: PropTypes.object,
    after: PropTypes.object,
  }),
};

/** A field list, or `(summary, detail) => string[]` for fields hidden on some rows only. */
const AuditHiddenFieldsPropType = PropTypes.oneOfType([AuditFieldListPropType, PropTypes.func]);

/** Panels that take summarised changes out of the field diff, by `summary.kind`, in display order. */
export const AuditChangePanelsPropType = PropTypes.arrayOf(
  PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    kinds: PropTypes.arrayOf(PropTypes.string).isRequired,
    subtitle: PropTypes.elementType,
  }),
);

const ShadowedTogglePropType = PropTypes.shape({
  label: PropTypes.string.isRequired,
});

export const AuditRowDecorationPropType = PropTypes.shape({
  chips: PropTypes.arrayOf(PropTypes.node),
  muted: PropTypes.bool,
  note: PropTypes.node,
  mutedFields: AuditFieldListPropType,
});

/** The optional extension props, shared by EntityAuditHistory and EntityAuditHistoryDrawer. */
export const AuditExtensionPropTypes = {
  renderers: AuditRenderersPropType,
  fieldRenderers: AuditFieldRenderersPropType,
  hiddenFields: AuditHiddenFieldsPropType,
  snapshotExcludedFields: AuditFieldListPropType,
  getRowDecoration: PropTypes.func,
  shadowedToggle: ShadowedTogglePropType,
  renderRowActions: PropTypes.func,
  renderDetailExtras: PropTypes.func,
  changePanels: AuditChangePanelsPropType,
  isSnapshotHidden: PropTypes.bool,
  automaticFields: AuditFieldListPropType,
};
